import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const ModelNumberEmptyState = {
  selectedModelNumber: null,
};

// export const CategoryKey = 'categories';

export const modelNumberSlice = createSlice({
  name: 'modelNumber',
  initialState: getLocalStorage(LocalStorageTypes.MODELNUMBER)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.MODELNUMBER))
    : ModelNumberEmptyState,
  reducers: {
    setModelNumber: (state, action) => {
      state.selectedModelNumber = action.payload;
      // Optionally, persist selectedModelNumber to local storage
      persistLocalStorage(LocalStorageTypes.MODELNUMBER, state);
    },
    resetModelNumber: () => ModelNumberEmptyState,
  },
});

export const { setModelNumber, resetModelNumber } = modelNumberSlice.actions;
